module.exports = __webpack_public_path__ + "81db2211f7522285dd1ab26f6f786621.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/ticketing.svg
// module id = 1935
// module chunks = 0